import { type TableSortingType } from './tableSortingStore.types.js';

export const DEFAULT_SORTING_STATE: TableSortingType = {};
